import { render } from "./EmailListItem.vue?vue&type=template&id=073c67e1&scoped=true"
import script from "./EmailListItem.vue?vue&type=script&lang=ts"
export * from "./EmailListItem.vue?vue&type=script&lang=ts"

import "./EmailListItem.vue?vue&type=style&index=0&id=073c67e1&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-073c67e1"

export default script